import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ListingSearchFilter } from '../interfaces/listing-search-filter';
import * as moment from 'moment';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material';
import { MomentDateAdapter, MAT_MOMENT_DATE_FORMATS } from '@angular/material-moment-adapter';

@Component({
  selector: 'mandae-listing-search',
  templateUrl: './listing-search.component.html',
  styleUrls: ['./listing-search.component.scss'],
  providers: [
    {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
    {provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS},
  ]
})
export class ListingSearchComponent implements OnInit {
  public needle: string;
  public needleStart: moment.Moment;
  public needleEnd: moment.Moment;
  public selectedFilter: ListingSearchFilter = null;

  public presetRanges;

  @Input()
  public searchFilter: ListingSearchFilter[] = [];

  @Output() search = new EventEmitter<any>(true);

  constructor() {
    this.setupPresets();
  }

  ngOnInit() {
  }

  sendSearch() {
    let obj = {};
    if (this.needle) {
      obj = {
        searchBy: this.selectedFilter.value,
        value: this.needle,
      };
    } else if (this.needleStart || this.needleEnd) {
      obj = {
        searchBy: this.selectedFilter.value,
        valueStart: this.needleStart ? this.needleStart.format('YYYY-MM-DD') : undefined,
        valueEnd: this.needleEnd ? this.needleEnd.format('YYYY-MM-DD') : undefined,
      };
    }
    this.search.emit(obj);
  }

  reset() {
    this.search.emit({});
  }

  selectRangePreset(presetItem) {
    this.needleStart = presetItem.range.fromDate;
    this.needleEnd = presetItem.range.toDate;

    this.sendSearch();
  }

  private setupPresets() {
    const today = moment();
    const tomorrow = moment(today).add(1, 'days');
    const minus7 = moment(today).subtract(7, 'days');
    const minus30 = moment(today).subtract(30, 'days');
    const currMonthStart = moment(today).startOf('month');
    const currMonthEnd = moment(today).endOf('month');
    const lastMonthStart = moment(today).subtract(1, 'month').startOf('month');
    const lastMonthEnd = moment(today).subtract(1, 'month').endOf('month');

    this.presetRanges =  [
      { displayValue: 'Hoje', range: { fromDate: today, toDate: tomorrow } },
      { displayValue: 'Últimos 7 dias', range: { fromDate: minus7, toDate: today } },
      { displayValue: 'Últimos 30 dias', range: { fromDate: minus30, toDate: today } },
      { displayValue: 'Este mês', range: { fromDate: currMonthStart, toDate: currMonthEnd } },
      { displayValue: 'Mês passado', range: { fromDate: lastMonthStart, toDate: lastMonthEnd  }}
    ];
  }


}
